import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import isEmpty from 'lodash/isEmpty';

import BlockComponent from './BlockComponent';
import blockDefinition from './definitions/link.json';

const propTypes = {
    url: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    description: PropTypes.string,
    target: PropTypes.string,
};

const defaultProps = {
    url: null,
    title: null,
    link: null,
    description: null,
    target: '_blank',
};

class LinkBlock extends BlockComponent {

    render() {
        const {
            url,
            title,
            link,
            description,
            target,
        } = this.props;

        const className = classNames({
            'block-link': true,
        });

        return (
            <div className={className}>
                { !isEmpty(title) ? (
                    <h2 className="title">{title}</h2>
                ) : null }
                { !isEmpty(url) ? (
                    <div className="link">
                        <a href={url} target={target}>{ !isEmpty(link) ? link : 'Read more' }&nbsp;&gt;</a>
                    </div>
                ) : null }
                { !isEmpty(description) ? (
                    <div className="text">
                        <ReactMarkdown source={description} />
                    </div>
                ) : null }
            </div>
        );
    }
}

LinkBlock.propTypes = propTypes;
LinkBlock.defaultProps = defaultProps;
LinkBlock.blockDefinition = blockDefinition;

export default LinkBlock;



// WEBPACK FOOTER //
// ./components/blocks/Link.jsx